import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { NavigationService } from '../services/navigation.service';
import { WhiteLabelService } from '../services/white-label.service';
import { isCommitteeAllowedUrl } from '../shared/constants/committee-access.constants';
import { isProprietorAllowedUrl, PROPRIETOR_DEFAULT_ROUTE } from '../shared/constants/proprietor-access.constants';

@Injectable()
export class Roles implements CanActivate {
  constructor(
    private authService: AuthService,
    private navigationService: NavigationService,
    private whiteLabelService: WhiteLabelService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    const user = this.authService.getUser();
    if (!user) {
      this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
      return false;
    }
    if (user.buildings?.length) {
      this.whiteLabelService.setSessionLoginPathFromBuilding(user.buildings[0]);
    }
    const isAdmin = user.roles.indexOf('admin') > -1;
    const isVigilant = user.roles.indexOf('vigilant') > -1;
    const isTenant = user.roles.indexOf('tenant') > -1;
    const isProprietor = user.roles.indexOf('proprietor') > -1;
    const isCommittee = user.roles.indexOf('committee') > -1;
    const isCustomized = user.roles.indexOf('customized') > -1;
    const isSuperAdmin = user.roles.indexOf('superAdmin') > -1;
    const inInvitations = state.url === '/app/invitations';
    const inHome = state.url === '/app';
    if (isSuperAdmin) return true;

    if (isAdmin) {
      const isMacroCommunityFather = this.authService.getBuildingIsMacroFather();
      if (isMacroCommunityFather) {
        let regexMacroRoutes = /\/app-community/i;
        if ( regexMacroRoutes.test(state.url)) return true;
        this.router.navigate(['/app-community']);
        return false;
      }
      return true;
    }
    if (isCommittee && !isAdmin && !isSuperAdmin) {
      const committeeContextAllowed = isCommitteeAllowedUrl(state.url)   
      if (committeeContextAllowed) {
        return true;
      }
      const targetRoute = this.navigationService.getTargetRouteForUser(user);
      this.router.navigate([targetRoute]);
      return false;
    }
    if (isProprietor) {
      // Solo proprietor puro: admin+proprietor ya salió arriba como admin.
      if (isProprietorAllowedUrl(state.url)) return true;
      this.router.navigate([PROPRIETOR_DEFAULT_ROUTE]);
      return false;
    }

    if (isVigilant) {
      if (inInvitations) return true;
      this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
      return false;
    }

    if (isTenant) {
      if (inHome) return true;
      this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
      return false;
    }

    if (isCustomized) {
      if (this.navigationService.hasAccessToRoute(user, state.url)) {
        return true;
      }
      const targetRoute = this.navigationService.getTargetRouteForUser(user);
      this.router.navigate([targetRoute]);
      return false;
    }

    this.router.navigateByUrl(this.whiteLabelService.getLoginRedirectUrl());
    return false;
  }
}
